/* eslint-disable import/no-named-as-default */
import React, { FunctionComponent } from "react";
import { Provider } from "react-redux";
import PropTypes from "prop-types";
import store from "../../store";
import EmployerAnalytics from "./EmployerAnalytics";

export interface IProviderProps {
  currencySymbol: string;
}

const ProviderComponent: FunctionComponent<IProviderProps> = ({
  currencySymbol,
}) => (
  <Provider store={store}>
    <EmployerAnalytics currencySymbol={currencySymbol} />
  </Provider>
);

ProviderComponent.propTypes = {
  currencySymbol: PropTypes.string.isRequired,
};
export default ProviderComponent;
